/**
 * Config
 * Location Autocomplete
 * @author Rhys Lloyd
 */

let googleApiKey = undefined;
const mapsKeyElement = document.querySelector('meta[name="config:keys.google-maps"]');
if(mapsKeyElement) {
	googleApiKey = mapsKeyElement.content;
}


/**
 * Google API Key
 * @type {string}
 */
export const GOOGLE_API_KEY = googleApiKey;


// WEBPACK FOOTER //
// ./project/client/src/core/services/google-maps-api/config.js